<template>
    <nav
        class="navbar navbar-expand navbar-light bg-white topbar mb-4 fixed-top shadow navbar-custom"
        :class="{ 'is-sidebar-collapsed': sidebarCollapsed }"
    >

        <!-- Sidebar Toggle (Topbar) -->
        <button
            class="btn btn-link d-none d-md-inline-flex rounded-circle mr-2 sidebar-collapse-toggle"
            type="button"
            :aria-label="sidebarCollapsed ? 'Expand navigation sidebar' : 'Collapse navigation sidebar'"
            :aria-pressed="sidebarCollapsed.toString()"
            @click="$emit('toggle-sidebar-collapse')"
        >
            <i :class="['pi', sidebarCollapsed ? 'pi-angle-right' : 'pi-angle-left']" aria-hidden="true"></i>
        </button>

        <button
            id="sidebarToggleTop"
            class="btn btn-link d-md-none rounded-circle mr-3"
            type="button"
            aria-controls="admin-sidebar"
            :aria-expanded="sidebarOpen.toString()"
            :aria-label="sidebarOpen ? 'Close navigation menu' : 'Open navigation menu'"
            @click="$emit('toggle-sidebar')"
        >
            <i class="pi pi-bars" aria-hidden="true"></i>
        </button>

        <!-- Topbar Navbar -->
        <ul class="navbar-nav ml-auto">

            <!-- Nav Item - Search Dropdown (Visible Only XS) -->
            <li class="nav-item dropdown no-arrow d-sm-none">
                <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button"
                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-search fa-fw"></i>
                </a>
                <!-- Dropdown - Messages -->
                <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                     aria-labelledby="searchDropdown">
                    <form class="form-inline mr-auto w-100 navbar-search">
                        <div class="input-group">
                            <input type="text" class="form-control bg-light border-0 small"
                                   placeholder="Search for..." aria-label="Search"
                                   aria-describedby="basic-addon2">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button">
                                    <i class="fas fa-search fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </li>

            <!-- Nav Item - Alerts -->
            <li class="nav-item dropdown no-arrow mx-1">
                <a class="nav-link dropdown-toggle" href="#" id="alertsDropdown" role="button"
                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-bell fa-fw"></i>
                    <!-- Counter - Alerts -->
                    <span class="badge badge-danger badge-counter">3+</span>
                </a>
                <!-- Dropdown - Alerts -->
                <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                     aria-labelledby="alertsDropdown">
                    <h6 class="dropdown-header">
                        Alerts Center
                    </h6>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="mr-3">
                            <div class="icon-circle bg-primary">
                                <i class="fas fa-file-alt text-white"></i>
                            </div>
                        </div>
                        <div>
                            <div class="small text-gray-500">December 12, 2019</div>
                            <span class="font-weight-bold">A new monthly report is ready to download!</span>
                        </div>
                    </a>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="mr-3">
                            <div class="icon-circle bg-success">
                                <i class="fas fa-donate text-white"></i>
                            </div>
                        </div>
                        <div>
                            <div class="small text-gray-500">December 7, 2019</div>
                            $290.29 has been deposited into your account!
                        </div>
                    </a>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="mr-3">
                            <div class="icon-circle bg-warning">
                                <i class="fas fa-exclamation-triangle text-white"></i>
                            </div>
                        </div>
                        <div>
                            <div class="small text-gray-500">December 2, 2019</div>
                            Spending Alert: We've noticed unusually high spending for your account.
                        </div>
                    </a>
                    <a class="dropdown-item text-center small text-gray-500" href="#">Show All Alerts</a>
                </div>
            </li>

            <!-- Nav Item - Messages -->
            <li class="nav-item dropdown no-arrow mx-1" style="display: none">
                <a class="nav-link dropdown-toggle" href="#" id="messagesDropdown" role="button"
                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-envelope fa-fw"></i>
                    <!-- Counter - Messages -->
                    <span class="badge badge-danger badge-counter">7</span>
                </a>
                <!-- Dropdown - Messages -->
                <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                     aria-labelledby="messagesDropdown">
                    <h6 class="dropdown-header">
                        Message Center
                    </h6>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="dropdown-list-image mr-3">
                            <img class="rounded-circle" src="/img/undraw_profile_1.svg"
                                 alt="...">
                            <div class="status-indicator bg-success"></div>
                        </div>
                        <div class="font-weight-bold">
                            <div class="text-truncate">Hi there! I am wondering if you can help me with a
                                problem I've been having.
                            </div>
                            <div class="small text-gray-500">Emily Fowler · 58m</div>
                        </div>
                    </a>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="dropdown-list-image mr-3">
                            <img class="rounded-circle" src="/img/undraw_profile_2.svg"
                                 alt="...">
                            <div class="status-indicator"></div>
                        </div>
                        <div>
                            <div class="text-truncate">I have the photos that you ordered last month, how
                                would you like them sent to you?
                            </div>
                            <div class="small text-gray-500">Jae Chun · 1d</div>
                        </div>
                    </a>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="dropdown-list-image mr-3">
                            <img class="rounded-circle" src="/img/undraw_profile_3.svg"
                                 alt="...">
                            <div class="status-indicator bg-warning"></div>
                        </div>
                        <div>
                            <div class="text-truncate">Last month's report looks great, I am very happy with
                                the progress so far, keep up the good work!
                            </div>
                            <div class="small text-gray-500">Morgan Alvarez · 2d</div>
                        </div>
                    </a>
                    <a class="dropdown-item d-flex align-items-center" href="#">
                        <div class="dropdown-list-image mr-3">
                            <img class="rounded-circle" src="https://source.unsplash.com/Mv9hjnEUHR4/60x60"
                                 alt="...">
                            <div class="status-indicator bg-success"></div>
                        </div>
                        <div>
                            <div class="text-truncate">Am I a good boy? The reason I ask is because someone
                                told me that people say this to all dogs, even if they aren't good...
                            </div>
                            <div class="small text-gray-500">Chicken the Dog · 2w</div>
                        </div>
                    </a>
                    <a class="dropdown-item text-center small text-gray-500" href="#">Read More Messages</a>
                </div>
            </li>

            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item">
                <a class="nav-link" href="#" id="userDropdown" role="button"
                   aria-haspopup="true" aria-controls="userMenu"
                   :aria-expanded="userMenuOpen.toString()"
                   @click.prevent="onToggleUserMenu">
                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">
                        <strong>{{ user.fullName }}</strong> - {{ user.roleName }}
                    </span>
                    <img class="img-profile rounded-circle" src="/img/undraw_profile.svg" style="display: none">
                </a>
                <!-- Dropdown - User Information -->
                <Menu
                    ref="userMenu"
                    id="userMenu"
                    class="shadow"
                    :model="userMenuItems"
                    :popup="true"
                    appendTo="body"
                    @hide="userMenuOpen = false"
                />
            </li>

        </ul>

    </nav>

</template>

<script>
import {defineComponent} from 'vue'
import Menu from 'primevue/menu';

export default defineComponent({
    name: "Navbar",
    components: {
        Menu
    },
    props: {
        sidebarOpen: {
            type: Boolean,
            default: false
        },
        sidebarCollapsed: {
            type: Boolean,
            default: false
        }
    },
    emits: ['toggle-sidebar', 'toggle-sidebar-collapse'],
    data() {
        return {
            user: {
                fullName: '',
                roleId: '',
                roleName: ''
            },
            userMenuOpen: false
        }
    },
    computed: {
        userMenuItems() {
            return [
                {label: 'Profile', icon: 'fas fa-user fa-sm fa-fw mr-2 text-gray-400'},
                {label: 'Settings', icon: 'fas fa-cogs fa-sm fa-fw mr-2 text-gray-400'},
                {label: 'Activity Log', icon: 'fas fa-list fa-sm fa-fw mr-2 text-gray-400'},
                {separator: true},
                {
                    label: 'Logout',
                    icon: 'fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400',
                    command: () => this.onLogout()
                }
            ]
        }
    },
    methods: {
        // Menu.toggle() flips its own overlay, so mirroring it here keeps
        // aria-expanded in step; @hide covers the outside-click close.
        onToggleUserMenu(event) {
            this.$refs.userMenu.toggle(event)
            this.userMenuOpen = !this.userMenuOpen
        },
        onLogout() {
            this.$store.dispatch('onLogout')
            this.$router.push('/')
        }
    },
    mounted() {
        this.user = this.$store.getters.getUser
    }
})
</script>


<style scoped>
.navbar-custom {
    position: fixed !important;
    top: 0;
    left: 224px; /* Sidebar width */
    right: 0;
    z-index: 1030;
    height: 4.375rem; /* Standard navbar height */
    padding: 0 1.5rem;
    margin-bottom: 0 !important;
}

@media (min-width: 769px) {
    .navbar-custom.is-sidebar-collapsed {
        left: 72px;
    }

    .sidebar-collapse-toggle {
        width: 2.5rem;
        height: 2.5rem;
        color: #3656bf;
    }

    .sidebar-collapse-toggle:focus-visible {
        outline: 3px solid #3656bf;
        outline-offset: 2px;
    }
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
    .navbar-custom {
        left: 0; /* Full width on mobile when sidebar is collapsed */
        padding: 0 1rem;
    }

    #sidebarToggleTop {
        width: 2.75rem;
        height: 2.75rem;
        color: #3656bf;
    }

    #sidebarToggleTop:focus-visible {
        outline: 3px solid #3656bf;
        outline-offset: 2px;
    }
}

/* Ensure dropdown menus appear above other content */
.navbar-custom .dropdown-menu {
    z-index: 1031;
}
</style>
